// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1bb9bedf","213":"e1b1ae72","239":"2383f2a4","520":"c8926345","667":"a59861da","858":"2807cff4"}[chunkId] + ".chunk.js";
};